<template>
  <div class="activityCompletion flexcenter">
    <transition>
      <div class="activity flexcenter">
        <div class="activityTitle">
          <h3>再チャレンジしますか？</h3>
        </div>
        <div class="activityContent">
          <div class="activityScore flexcenter">
            <div class="item">
              <ul class="score-list">
                <li class="flexbetween"><span class="ok align-left">正解</span><span class="align-right">{{ ok }}</span></li>
                <li class="flexbetween"><span class="ng align-left">不正解</span><span class="align-right">{{ ng }}</span></li>
                <li class="flexbetween"><span class="skip align-left">スキップ</span><span class="align-right">{{ skip }}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="activityResetFooter">
          <div class="buttons flexbetween">
            <button type=button v-on:click="clickButton('home')" class="home">ホーム</button>
            <button type=button v-on:click="clickButton('lessonScore')" class="continue">他の問題を解く</button>
            <button type=button v-on:click="clickButton('reset')" class="retry">はい</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'scoreReset',
  data () {
    return {
      ok: 0,
      ng: 0,
      skip: 0
    }
  },
  mixins: [
    common,
  ],
  methods: {
    clickButton: function(kind) {
      this.log("ScoreReset clickButton kind: " + kind)
      this.$emit('clickButton', kind)
    }
  },
  created: function() {
    this.log("ScoreReset start created")

    var pathstepIndex = this.$store.getters.pathstepIndex
    var currentPath = this.$store.getters.currentPath
    var pathstep = currentPath.pathsteps[pathstepIndex]

    this.ok = pathstep.ok
    this.ng = pathstep.ng
    this.skip = pathstep.skip
  },
  mounted: function() {
    this.log("ScoreReset start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ScoreReset.vue?d4d4acf6